import { useState } from "react";
import { Download, Upload } from "lucide-react";
import { toast } from "sonner";
import { errMsg, eur, useApi } from "@/lib/api";

const SAMPLE = `Nome Prodotto;Descrizione;Categoria;Prezzo Bronze (€);Prezzo Gold (€);Prezzo Diamond (€);Quantità/Stock;URL Immagine
Weekend in Toscana 2 notti;Soggiorno per due persone con colazione;Viaggi;320;299;279;10;https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=800
Cena degustazione;Menu di 5 portate con vini;Ristorazione;90;84;78;20;
`;

export function CsvImport({ onDone }) {
  const api = useApi();
  const [text, setText] = useState("");
  const [preview, setPreview] = useState(null);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const t = await file.text();
    setText(t);
    try {
      setPreview(await api("post", "/partner/offers/import/preview", { csv_text: t }));
    } catch (err) {
      setPreview(null);
      toast.error(errMsg(err));
    }
    e.target.value = "";
  };

  const commit = async () => {
    try {
      const r = await api("post", "/partner/offers/import", { csv_text: text });
      toast.success(`Importati: ${r.created} nuovi, ${r.updated} aggiornati. In attesa di approvazione.`);
      setPreview(null);
      onDone?.();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  const download = () => {
    const url = URL.createObjectURL(new Blob(["\ufeff" + SAMPLE], { type: "text/csv;charset=utf-8" }));
    const a = Object.assign(document.createElement("a"), { href: url, download: "listino-esempio.csv" });
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-5" data-testid="csv-import">
      <p className="text-sm text-slate-400">Colonne riconosciute: Nome Prodotto, Descrizione, Categoria, Prezzo Bronze (€), Prezzo Gold (€), Prezzo Diamond (€), Quantità/Stock, URL Immagine. Se mancano Gold o Diamond si usa il prezzo Bronze. I prodotti con lo stesso nome vengono aggiornati.</p>
      <div className="flex flex-wrap gap-3">
        <label className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-amber-500 px-5 py-2 text-sm font-semibold text-black hover:bg-amber-400">
          <Upload className="h-4 w-4" /> Carica file .csv
          <input data-testid="csv-file-input" type="file" accept=".csv,text/csv" className="hidden" onChange={onFile} />
        </label>
        <button data-testid="csv-sample-download" onClick={download} className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2 text-sm text-white hover:bg-white/10">
          <Download className="h-4 w-4" /> Scarica CSV di esempio
        </button>
      </div>
      {preview && (
        <div className="space-y-3">
          <p className="text-sm text-slate-300" data-testid="csv-preview-summary">Righe valide: <b className="text-emerald-400">{preview.valid}</b> · Con errori: <b className="text-red-400">{preview.invalid}</b></p>
          <div className="overflow-x-auto rounded-2xl border border-white/10">
            <table className="w-full text-left text-sm">
              <thead className="bg-white/5 text-xs uppercase text-slate-400"><tr><th className="p-3">Riga</th><th className="p-3">Nome</th><th className="p-3">Categoria</th><th className="p-3">B / G / D</th><th className="p-3">Stock</th><th className="p-3">Esito</th></tr></thead>
              <tbody>
                {preview.rows.map((r) => (
                  <tr key={r.line} className="border-t border-white/5">
                    <td className="p-3 text-slate-500">{r.line}</td>
                    <td className="p-3 text-white">{r.name}</td>
                    <td className="p-3">{r.category}</td>
                    <td className="p-3">{r.price_bronze != null ? `${eur(r.price_bronze)} / ${eur(r.price_gold)} / ${eur(r.price_diamond)}` : "—"}</td>
                    <td className="p-3">{r.stock}</td>
                    <td className="p-3">{r.errors.length ? <span className="text-red-400">{r.errors.join("; ")}</span> : <span className="text-emerald-400">{r.action}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button data-testid="csv-commit" disabled={!preview.valid} onClick={commit} className="rounded-full bg-amber-500 px-5 py-2 text-sm font-semibold text-black disabled:opacity-50">Conferma importazione ({preview.valid})</button>
        </div>
      )}
    </div>
  );
}
